import { axiosInstanceWithToken } from 'utils/axios';
import { IBulkUpdateRequest, IUserResource, IBulkDeleteRequest, IUserResourceWithRelations } from '../../server/types';

export const updateUser = async (id: string, data: Partial<Omit<IUserResource, 'role'> & { role: string }>) =>
  axiosInstanceWithToken().patch<IUserResourceWithRelations>(`users/${id}`, data);

export const fetchUsers = async () => axiosInstanceWithToken().get<IUserResourceWithRelations[]>('users');

export const deleteUser = async (id: string) => axiosInstanceWithToken().delete<void>(`users/${id}`);

export const deleteUsers = async (data: IBulkDeleteRequest) =>
  axiosInstanceWithToken().post<void>(`users/delete`, data);

export const updateUsers = async (data: IBulkUpdateRequest<Omit<IUserResource, 'role'> & { role: string }>) =>
  axiosInstanceWithToken().post<IUserResourceWithRelations[]>(`users/update`, data);
